import logo from "./logo.svg";
import "./App.css";
import React, { useState } from "react";
import Web3 from "web3";

import Swal from "sweetalert2";
import { useCookies } from "react-cookie";
import ReactLoading from "react-loading";

function App() {
  const [cookies, setCookie, removeCookie] = useCookies(["instance-address"]);
  const [loadingText, setLoadingText] = useState("Deploying contract...");
  const [loading, setLoading] = useState(false);
  const DBT_ABI = [
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "_address",
          type: "address",
        },
      ],
      name: "NewVestingWallet",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "receiver",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "payoutPercent",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "payoutAmount",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "payoutBalance",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      name: "_nativeBeneficiaries",
      outputs: [
        {
          internalType: "uint256",
          name: "beneficiariePayoutPercent",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "beneficiariePayoutAmount",
          type: "uint256",
        },
        {
          internalType: "uint64",
          name: "vestingDurationSeconds",
          type: "uint64",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "_nativeDirectAmountHoldings",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "_payoutBalance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      name: "_tokenBeneficiaries",
      outputs: [
        {
          internalType: "bool",
          name: "enabled",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      name: "_tokensReleased",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "uint256",
              name: "beneficiariePayoutPercent",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "beneficiariePayoutAmount",
              type: "uint256",
            },
            {
              internalType: "uint64",
              name: "vestingDurationSeconds",
              type: "uint64",
            },
          ],
          internalType: "struct DBT.PayoutData",
          name: "beneficiarie_",
          type: "tuple",
        },
        {
          internalType: "address",
          name: "payoutAddress",
          type: "address",
        },
      ],
      name: "addNewNativeBeneficiarie",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "contract IERC20Upgradeable[]",
              name: "tokens",
              type: "address[]",
            },
            {
              internalType: "uint64[]",
              name: "vestingDurationSeconds",
              type: "uint64[]",
            },
            {
              internalType: "uint256[]",
              name: "beneficiariePayoutPercentPerToken",
              type: "uint256[]",
            },
            {
              internalType: "uint256[]",
              name: "beneficiariePayoutAmountPerToken",
              type: "uint256[]",
            },
            {
              internalType: "bool",
              name: "enabled",
              type: "bool",
            },
          ],
          internalType: "struct DBT.ERC20PayoutData",
          name: "beneficiarie_",
          type: "tuple",
        },
        {
          internalType: "address",
          name: "payoutAddress",
          type: "address",
        },
      ],
      name: "addNewTokenBeneficiarie",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "address_",
          type: "address",
        },
        {
          internalType: "uint64",
          name: "vestingDurationSeconds",
          type: "uint64",
        },
        {
          internalType: "uint256",
          name: "beneficiariePayoutPercentPerToken",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "beneficiariePayoutAmountPerToken",
          type: "uint256",
        },
        {
          internalType: "contract IERC20Upgradeable",
          name: "token_",
          type: "address",
        },
      ],
      name: "addNewTokenToERC20Beneficiarie",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "admin",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "address_",
          type: "address",
        },
      ],
      name: "approveLockoutReleaseForBeneficiarie",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "withdrawlerAddress_",
          type: "address",
        },
      ],
      name: "beginNativeVesting",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "withdrawlerAddress_",
          type: "address",
        },
      ],
      name: "beginTokenVesting",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "admin_",
          type: "address",
        },
      ],
      name: "initialize",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "dest",
          type: "address",
        },
      ],
      name: "payments",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "beneficiarieAddress_",
          type: "address",
        },
      ],
      name: "removeNativeBeneficiarie",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "beneficiarieAddress_",
          type: "address",
        },
      ],
      name: "removeTokenBeneficiarie",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address payable",
          name: "newAddress_",
          type: "address",
        },
        {
          internalType: "address",
          name: "oldAddress_",
          type: "address",
        },
      ],
      name: "updateNativeBeneficiariePayoutAddress",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address payable",
          name: "newAddress_",
          type: "address",
        },
        {
          internalType: "address",
          name: "oldAddress_",
          type: "address",
        },
      ],
      name: "updateTokenBeneficiariePayoutAddress",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "address_",
          type: "address",
        },
      ],
      name: "withdrawERC20TokensForBeneficiarieADMIN",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "address_",
          type: "address",
        },
      ],
      name: "withdrawERC20TokensForBeneficiarieUSER",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "address_",
          type: "address",
        },
      ],
      name: "withdrawETHForBeneficiarieADMIN",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "address_",
          type: "address",
        },
      ],
      name: "withdrawETHForBeneficiarieUSER",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address payable",
          name: "payee",
          type: "address",
        },
      ],
      name: "withdrawPayments",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      stateMutability: "payable",
      type: "receive",
    },
  ];
  const ethEnabled = () => {
    if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
      window.ethereum.enable();
      return true;
    }
    return false;
  };
  const addNewERC20Beneficiarie = async () => {
    if (!ethEnabled()) {
      console.log("Metamask not installed");
    } else {
      const contract = new window.web3.eth.Contract(
        DBT_ABI,
        cookies["instance-address"]
      );
      const payoutAddress = await Swal.fire({
        title: "Enter the address of the beneficiary",
        input: "text",
        icon: "question",
        inputLabel: "Enter the address of the beneficiary",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutAddress.isConfirmed == false) return;
      const payoutPercent = await Swal.fire({
        title: "Enter a percentage",
        input: "range",
        icon: "question",
        inputAttributes: {
          min: 0,
          max: 100,
          step: 1,
        },
        inputValue: 25,
        inputLabel:
          "Enter the percentage of funds to be distributed to this beneficiarie",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutPercent.isConfirmed == false) return;
      const absolutePayout = await Swal.fire({
        title: "Enter a number",
        input: "text",
        icon: "question",
        inputLabel:
          "Enter the amount of funds to be distributed to this beneficiarie absolutely",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (absolutePayout.isConfirmed == false) return;
      const vestingPayout = await Swal.fire({
        title: "Vest assets?",
        input: "text",
        icon: "question",
        inputLabel:
          "Would you like to add a vesting period to this beneficiary if not just leave it as 0 (UNIT: SECONDS)",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (vestingPayout.isConfirmed == false) return;
      const address = await Swal.fire({
        title: "What is the address for the ERC20 token?",
        input: "text",
        icon: "question",
        inputLabel: "Add the address for the ERC20 token",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      setLoading(true);
      await contract.methods
        .addNewTokenBeneficiarie(
          {
            beneficiariePayoutPercentPerToken: [payoutPercent.value],
            beneficiariePayoutAmountPerToken: [absolutePayout.value],
            vestingDurationSeconds: [vestingPayout.value],
            enabled: true,
            tokens: [address.value],
          },
          payoutAddress.value
        )
        .send({
          from: window.web3.currentProvider.selectedAddress,
          to: cookies["instance-address"],
        });
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Beneficiary created",
        text: "Your ERC20 Beneficiary has been created successfully!",
      });
    }
  };
  const addNewNativeBeneficiarie = async () => {
    if (!ethEnabled()) {
      console.log("Metamask not installed");
    } else {
      const contract = new window.web3.eth.Contract(
        DBT_ABI,
        cookies["instance-address"]
      );
      const payoutAddress = await Swal.fire({
        title: "Enter the address of the beneficiary",
        input: "text",
        icon: "question",
        inputLabel: "Enter the address of the beneficiary",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutAddress.isConfirmed == false) return;
      const payoutPercent = await Swal.fire({
        title: "Enter a percentage",
        input: "range",
        icon: "question",
        inputAttributes: {
          min: 0,
          max: 100,
          step: 1,
        },
        inputValue: 25,
        inputLabel:
          "Enter the percentage of funds to be distributed to this beneficiarie",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutPercent.isConfirmed == false) return;
      const absolutePayout = await Swal.fire({
        title: "Enter a number",
        input: "text",
        icon: "question",
        inputLabel:
          "Enter the amount of funds to be distributed to this beneficiarie absolutely",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (absolutePayout.isConfirmed == false) return;
      const vestingPayout = await Swal.fire({
        title: "Vest assets?",
        input: "text",
        icon: "question",
        inputLabel:
          "Would you like to add a vesting period to this beneficiary if not just leave it as 0 (UNIT: SECONDS)",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (vestingPayout.isConfirmed == false) return;
      const data = {
        beneficiariePayoutPercent: parseInt(payoutPercent.value),
        beneficiariePayoutAmount: parseInt(absolutePayout.value),
        vestingDurationSeconds: parseInt(vestingPayout.value),
      };
      setLoading(true);
      await contract.methods
        .addNewNativeBeneficiarie(data, payoutAddress.value)
        .send({
          from: window.web3.currentProvider.selectedAddress,
          to: cookies["instance-address"],
        });
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Beneficiary created",
        text: "Your Native Beneficiary has been created successfully!",
      });
    }
  };
  const removeLockout = async () => {
    if (!ethEnabled()) {
      console.log("Metamask not installed");
    } else {
      setLoading(true);
      const contract = new window.web3.eth.Contract(
        DBT_ABI,
        cookies["instance-address"]
      );
      const payoutAddress = await Swal.fire({
        title: "Enter the address of the beneficiary",
        input: "text",
        icon: "question",
        inputLabel: "Enter the address of the beneficiary",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutAddress.isConfirmed == false) return;
      await contract.methods
        .approveLockoutReleaseForBeneficiarie(payoutAddress.value)
        .send({
          from: window.web3.currentProvider.selectedAddress,
          to: cookies["instance-address"],
        });
      setLoading(false);
    }
  };
  const withdrawETH = async () => {
    if (!ethEnabled()) {
      console.log("Metamask not installed");
    } else {
      const contract = new window.web3.eth.Contract(
        DBT_ABI,
        cookies["instance-address"]
      );
      const payoutAddress = await Swal.fire({
        title: "Enter the address of the beneficiary",
        input: "text",
        icon: "question",
        inputLabel: "Enter the address of the beneficiary",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutAddress.isConfirmed == false) return;

      await contract.methods
        .withdrawETHForBeneficiarieUSER(payoutAddress.value)
        .send({
          from: window.web3.currentProvider.selectedAddress,
          to: cookies["instance-address"],
        });
      await contract.methods
        .withdrawPayments(window.web3.currentProvider.selectedAddress)
        .send({
          from: window.web3.currentProvider.selectedAddress,
          to: cookies["instance-address"],
        });
    }
  };
  const withdrawERC20s = async () => {
    if (!ethEnabled()) {
      console.log("Metamask not installed");
    } else {
      const contract = new window.web3.eth.Contract(
        DBT_ABI,
        cookies["instance-address"]
      );
      const payoutAddress = await Swal.fire({
        title: "Enter the address of the beneficiary",
        input: "text",
        icon: "question",
        inputLabel: "Enter the address of the beneficiary",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });
      if (payoutAddress.isConfirmed == false) return;
      await contract.methods
        .withdrawERC20TokensForBeneficiarieUSER(payoutAddress.value)
        .send({
          from: window.web3.currentProvider.selectedAddress,
          to: cookies["instance-address"],
        });
    }
  };
  const deployContract = async () => {
    if (!ethEnabled()) {
      console.log("Metamask not installed");
    } else {
      setLoading(true);
      const bytecode =
        "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";
      const contract = new window.web3.eth.Contract(DBT_ABI);
      const deploy = await contract.deploy({ data: bytecode }).send({
        from: window.web3.currentProvider.selectedAddress,
      });
      setLoadingText("Initializing contract...");
      const deployedContract = new window.web3.eth.Contract(
        DBT_ABI,
        deploy._address
      );
      await deployedContract.methods
        .initialize(window.web3.currentProvider.selectedAddress)
        .send({
          from: window.web3.currentProvider.selectedAddress,
        });
      setCookie("instance-address", deploy._address);
      setLoadingText("Deploying contract...");
      setLoading(false);
    }
  };
  if (cookies["instance-address"] == undefined) {
    return (
      <div className="App min-h-screen bg-pblack flex justify-center items-center text-center p-2">
        <p className="text-gray-500 text-xs mt-2 absolute left-3 top-3">
          {window.web3.currentProvider.selectedAddress}
        </p>
        <p className="text-gray-500 text-xs mt-2 absolute right-3 top-3">
          Demo UI
        </p>
        <div className="flex justify-center items-center flex-col">
          {loading == false && (
            <h1 className="text-white text-3xl">Contract instance not found</h1>
          )}
          {loading && <h1 className="text-white text-3xl">{loadingText}</h1>}
          {loading && <ReactLoading type={"bars"} className="" />}
          {loading == false && (
            <button
              className="text-white bg-orange2 hover:bg-beef rounded w-60 h-10 mt-5 transition duration-200 ease-in-out"
              onClick={() => deployContract()}
            >
              Create new instance
            </button>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`App min-h-screen bg-pblack flex justify-center items-center text-center p-2 backdrop-blur-3xl ${
          loading == true ? "overlay" : ""
        }`}
      >
        {loading == true && (
          <ReactLoading type={"bars"} className="absolute " />
        )}
        <p className="text-gray-500 text-xs mt-2 absolute left-3 top-3">
          DBT Address: {cookies["instance-address"]}
        </p>
        <p className="text-gray-500 text-xs mt-2 absolute right-3 top-3">
          Demo UI
        </p>
        <div>
          <h1 className="text-3xl text-white dark:text-white">Admin portal:</h1>
          <button
            className="text-white bg-orange2 hover:bg-beef rounded w-60 h-10 mt-5 transition duration-200 ease-in-out"
            onClick={() => addNewNativeBeneficiarie()}
          >
            Create new Native Beneficiary
          </button>
          <button
            className="text-white bg-orange2 hover:bg-beef rounded w-60 h-10 mt-5 ml-5 transition duration-200 ease-in-out"
            onClick={() => addNewERC20Beneficiarie()}
          >
            Create new ERC20 Beneficiary
          </button>
          <button
            className="text-white bg-orange2 hover:bg-beef rounded w-60 h-10 mt-5 ml-5 transition duration-200 ease-in-out"
            onClick={() => removeLockout()}
          >
            Remove lockout
          </button>
          <h1 className="text-3xl text-white dark:text-white mt-5">
            User portal:
          </h1>
          <button
            className="text-white bg-orange3 hover:bg-beef rounded w-60 h-10 mt-5 ml-5 transition duration-200 ease-in-out"
            onClick={() => withdrawERC20s()}
          >
            Withdraw ERC20's
          </button>
          <button
            className="text-white bg-orange3 hover:bg-beef rounded w-60 h-10 mt-5 ml-5 transition duration-200 ease-in-out "
            onClick={() => withdrawETH()}
          >
            Withdraw ETH
          </button>
        </div>
      </div>
    );
  }
}

export default App;
